export const groupBy = <T>(items: T[], keyGetter: (item: T) => string) => {
  const map = new Map<string, T[]>();
  items.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
};

export const groupByMulti = <T>(
  items: T[],
  keyGetters: (item: T) => string[]
) => {
  const map = new Map<string, T[]>(); // <string[], T[]>
  items.forEach((item) => {
    const keys = keyGetters(item);
    keys.forEach((key) => {
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
  });
  return map;
};

export const groupByKeyAndSumByValue = <T>(
  items: T[],
  keyGetter: (item: T) => string,
  valueGetter: (item: T) => number
): Map<string, number> => {
  const map = new Map<string, number>();
  items.forEach((item) => {
    const key = keyGetter(item);
    const value = valueGetter(item);

    const collection = map.get(key);
    if (!collection) {
      map.set(key, value);
    } else {
      map.set(key, collection + value);
    }
  });

  return map;
};

export const groupByKeyAndSumByValueMulti = <T>(
  items: T[],
  keyGetters: (item: T) => string[],
  valueGetter: (item: T) => number
): Map<string, number> => {
  const map = new Map<string, number>();
  items.forEach((item) => {
    const keys = keyGetters(item);
    keys.forEach((key) => {
      const value = valueGetter(item);

      const collection = map.get(key);
      if (!collection) {
        map.set(key, value);
      } else {
        map.set(key, collection + value);
      }
    });
  });

  return map;
};

export const convertMapToArray = <TKey, TValue>(
  map: Map<TKey, TValue>
): { key: TKey; value: TValue }[] => {
  const array: { key: TKey; value: TValue }[] = [];

  map.forEach((value, key) => {
    array.push({
      key,
      value,
    });
  });
  return array;
};
